import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import * as spriteIcons from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { useUserProfile } from 'store'
import colors from 'styles/colors'
import { type Card } from 'types/api/payment'

interface SelectCardProps {
    cardList: { cards: Card[] }
    paymentMethod: {
        method: 'card' | 'deposit'
        cardId: string | undefined
        rebill?: boolean // Made optional
    }
    setPaymentMethod: (method: {
        method: 'card' | 'deposit'
        cardId: string | undefined
        rebill?: boolean // Made optional
    }) => void
}
export function SelectCard({
    cardList,
    paymentMethod,
    setPaymentMethod
}: SelectCardProps) {
    const userData = useUserProfile()

    return (
        <>
            {userData?.default_payment_method === 'wallet' && (
                <Wallet
                    setPaymentMethod={setPaymentMethod}
                    paymentMethod={paymentMethod}
                />
            )}
            {cardList?.cards?.map((card: Card) => (
                <SingleCard
                    card={card}
                    key={card.id}
                    paymentMethod={paymentMethod}
                    setPaymentMethod={setPaymentMethod}
                />
            ))}
            {userData?.default_payment_method === 'card' && (
                <Wallet
                    setPaymentMethod={setPaymentMethod}
                    paymentMethod={paymentMethod}
                />
            )}
        </>
    )
}

interface WalletProps {
    paymentMethod: {
        method: 'card' | 'deposit'
        cardId: string | undefined
        rebill?: boolean // Made optional
    }
    setPaymentMethod: (method: {
        method: 'card' | 'deposit'
        cardId: string | undefined
        rebill?: boolean // Made optional
    }) => void
}
function Wallet({ setPaymentMethod, paymentMethod }: WalletProps) {
    const { t } = useTranslation()
    return (
        <ActionCard
            icon={<spriteIcons.IconWallet />}
            text={
                <>
                    <CardText>{t('wallet')}</CardText>
                </>
            }
            iconSize='big'
            selected={paymentMethod.method === 'deposit'}
            clickFn={() => {
                setPaymentMethod({ method: 'deposit', cardId: undefined, rebill: paymentMethod?.rebill })
            }}
        />
    )
}
interface SingleCardProps {
    card: Card
    paymentMethod: {
        method: 'card' | 'deposit'
        cardId: string | undefined
        rebill?: boolean // Made optional
    }
    setPaymentMethod: (method: {
        method: 'card' | 'deposit'
        cardId: string | undefined
        rebill?: boolean // Made optional
    }) => void
}
function SingleCard({
    card,
    paymentMethod,
    setPaymentMethod
}: SingleCardProps) {
    return (
        <ActionCard
            icon={
                card.card_number.charAt(0) === '3' ? (
                    <spriteIcons.IconVisa />
                ) : (
                    <spriteIcons.IconMasterCard />
                )
            }
            iconSize='big'
            text={
                <>
                    {card.card_number.charAt(0) === '3' ? 'Visa' : 'Mastercard'}{' '}
                    {card.is_verified && <CardText>Verified</CardText>}
                </>
            }
            subtext={<CardNumber>{card.card_number}</CardNumber>}
            description={
                <CardDescription>{`Exp ${card.expiration_month}/${card.expiration_year}`}</CardDescription>
            }
            selected={paymentMethod.cardId === card.id}
            clickFn={() => {
                setPaymentMethod({ method: 'card', cardId: card.id, rebill: paymentMethod?.rebill })
            }}
        />
    )
}

const CardDescription = styled.span`
    color: ${colors.silverGray};
`
const CardText = styled.span`
    font-size: 1.2rem;
    color: ${colors.stormyBlue};
`
const CardNumber = styled.span`
    color: ${colors.stormyBlue};
`
